import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ColumnChangeBO, columnWidth } from '../../lov/lov.model';
import { ClientBO, clientFilter, EditDetailsClient, functionpermission, getClient, GetClientEmployeeRelationshipBO, GetListBase, QPfilter } from '../client-parent.model';
import { ClientHttpService } from '../client-parent.service';
import { clienttserivce } from '../clienttservice';
// import { clienttserivce } from '../client.service';
import * as FileSaver from 'file-saver';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { onboardingservice } from '../../onboarding/onboarding.service';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})

export class ClientListComponent implements OnInit {
  @Input() DataFromList: EditDetailsClient = new EditDetailsClient();
  @Output() EventToEdit = new EventEmitter<EditDetailsClient>();
  @ViewChild('grid') public grid: GridComponent;
  ClientStatus: [{ Key: string, Value: string }]
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  EditOptions: EditDetailsClient = new EditDetailsClient();
  filterOptions1: FilterSettingsModel;
  filterOptions: FilterSettingsModel;
  initialPage: object;
  public filterSettings: object;
  ISEDI271Client:boolean=false;
  public formatOptions1: object;
  public formatOptions: object;
  public wrapSettings: TextWrapSettingsModel;
  public data: Observable<DataStateChangeEventArgs>;
  QpStatusDropdown: [{ Key: number, Value: string }]
  ClientDropDown: [{ Key: string, Value: string }]
  arraycol: any = [];
  dropdata: string[] = []
  QPFilter: QPfilter = new QPfilter();
  saveClientEmployee: any = new GetClientEmployeeRelationshipBO();
  locationId: string = "00000000-0000-0000-0000-000000000000";
  filterstatuslid: any;
  statusList: any = []
  fp: functionpermission = new functionpermission();

  constructor(public http: ClientHttpService, public datepipe: DatePipe, public global: GlobalComponent, @Inject(clienttserivce) public clienttserivce: clienttserivce,public toastrService:ToastrService

  ,public httpService: onboardingservice) {
    this.global.checkforlogout();
   
    this.data = clienttserivce;
  }

  ngOnInit(): void {    
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000")  
     {
      return;
    }
    if (this.global.selectedLocationDropdown == null || this.global.selectedLocationDropdown == undefined || this.global.selectedLocationDropdown == '') {
      this.locationId = null;
      
    }
    else {
      this.locationId = this.global.selectedLocationDropdown;
    }
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.wrapSettings = { wrapMode: 'Content' };
    this.filterOptions = { type: 'Excel' };
    this.filterSettings = { type: 'Menu' };
    this.formatOptions1 = { type: 'date', format: 'MM/dd/yyyy HH:mm:ss' };
    this.filterOptions1 = { type: 'Menu' };
    this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    // let pag = JSON.parse(this.global.globalColumn.column)[0].Client.Pagesize;
    this.getStatus();
    
    this.wrapSettings = { wrapMode: 'Content' };
    // let pag = JSON.parse(this.global.globalColumn.column)[0].Client.Pagesize;
    this.filterOptions = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    // this.getClient.pageitem = pag
this.getpermission()
    
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Client");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.http.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
  }

  getclinetStatus() {
    let params = new URLSearchParams();
    this.http.getClientStatusDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {

      this.ClientStatus = JSON.parse(JSON.stringify(data));
      this.QpStatusDropdown = JSON.parse(JSON.stringify(data));
      this.dropdata = data.map(e => e.Value);

      this.ClientStatus.push({ Key: "00000000-0000-0000-0000-000000000000", Value: "All" });

      this.getClient.statusLId = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
      this.QPFilter.Status = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
      this.saveClientEmployee.statusLid = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
      this.getClientListDetails();
    })


    // let params = new URLSearchParams();
    // params.append("Code", "STATUS");
    // params.append("agencyId", this.global.globalAgencyId);
    // params.append("userId", this.global.userID);
    // let url = "api/LOV/getLovDropDown?"
    // this.http.getStatus(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {

    //   this.ClientStatus = JSON.parse(JSON.stringify(data));
    //   /// this.QpStatusDropdown= this.ClientStatus;
    //   this.QpStatusDropdown = JSON.parse(JSON.stringify(data));
    //   this.dropdata = data.map(e => e.Value);
    //   // this.eligiblitydropdata.push("Eligible");
    //   // this.eligiblitydropdata.push("Not Eligible");

    //   this.ClientStatus.push({ Key: 0, Value: "All" });

    //   this.getClient.statusLid = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
    //   this.QPFilter.Status = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
    //   this.saveClientEmployee.statusLid = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;

    //   this.getClientListDetails();
    // })

  }
  public dataChangeClient(state): void {
    let val = (state.action.requestType).toString();
    console.log("val.....", val)
    console.log("state.....", state)
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getClient.orderColumn = state.sorted[0].name;
        this.getClient.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      state.action.currentFilterObject.field === "phone1" ? state.action.currentFilterObject.value = state.action.currentFilterObject.value.replace(' ', "").replace('(', "").replace(')', "").replace('-', "") : state.action.currentFilterObject.value;
      if (state.action.currentFilterObject.field == "status_Name") {

        // this.getClient.value = this.ClientStatus.filter(e => e.Value == state.action.currentFilterObject.value)[0].Key.toString()
        this.getClient.field = state.action.currentFilterObject.field;
        // this.getClient.statusLId = this.ClientStatus.filter(e => e.Value == state.action.currentFilterObject.value)[0].Key
        this.getClient.value = state.action.currentFilterObject.value;
        // this.getClient.statusLId = state.action.currentFilterObject.value
        this.getClient.type = "string";
        this.getClient.operator = "equal";
      }
      else if (this.getClient.type == "number") {
        this.getClient.value = state.action.currentFilterObject.value.toString();
        this.getClient.field = state.action.currentFilterObject.field;
        this.getClient.operator = state.action.currentFilterObject.operator;
      }
      else if (this.getClient.type == "date" || this.getClient.type == "datetime") {     
        this.getClient.value = state.action.currentFilterObject.value;
        this.getClient.field = state.action.currentFilterObject.field;
       // this.getClient.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString())
        this.getClient.value = (this.getClient.value!= null && this.getClient.value != "" && this.getClient.value != undefined)
        ? this.global.getDateTimeString(this.getClient.value)
        : this.getClient.value;

        console.log("this.getClient.value....", this.getClient.value)
        // if(this.getClient.field =='dob') {
        //   console.log("this.getClient.field....",this.getClient.field )
        //   this.getClient.value = (this.getClient.value && this.getClient.value !== "" && this.getClient.value !== undefined)
        //   ? this.global.getDateTimeString(this.getClient.value)
        //   : this.getClient.value;
        //   console.log("this.getClient.value",this.getClient.field + this.getClient.value)
        // }
      }
      else {
        this.getClient.value = state.action.currentFilterObject.value;
        this.getClient.field = state.action.currentFilterObject.field;
        this.getClient.matchCase = state.action.currentFilterObject.matchCase;
        this.getClient.operator = state.action.currentFilterObject.operator;

      }
      if(this.getClient.type != "string" && (this.getClient.value == null || this.getClient.value == undefined || this.getClient.value == '')){
        this.getClient.field = "Name";
        this.getClient.matchCase = false;
        this.getClient.operator = "contains";
        this.getClient.value = "";
        this.getClient.type = "string"
      }
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.getClient.field = "Name";
        this.getClient.matchCase = false;
        this.getClient.operator = "contains";
        this.getClient.value = "";
        this.getClient.type = "string"
        // this.getClient.statusLId = this.ClientStatus[0]?.Key
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Client.Pagesize != state.take) {
          this.arraycol[0].Client.Pagesize = state.take
          this.SaveColumnwidth();
          // }
        }
      }
    }
    this.getClientListDetails();
  }

  // public dataChangeClient(state): void {
  //   let val = (state.action.requestType).toString();
  //   if (val != "filterchoicerequest") {
  //     if ((state.sorted || []).length) {
  //       this.getClient.orderColumn = state.sorted[0].name;
  //       this.getClient.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
  //     }
  //   }
  //   if (val == "filtering" && state.action.action != "clearFilter"){
  //     this.getClient.value = state.action.currentFilterObject.value;
  //     this.getClient.field = state.action.currentFilterObject.field;
  //     this.getClient.matchCase = state.action.currentFilterObject.matchCase;
  //     this.getClient.operator = state.action.currentFilterObject.operator;
  //   }
  //   else {
  //     if (val == "filtering" && state.action.action == "clearFilter") {
  //       this.getClient.field = "Name";
  //       this.getClient.matchCase = false;
  //       this.getClient.operator = "contains";
  //       this.getClient.value = "";
  //       this.getClient.type = "string"
  //     }
  //   }
  //   if (val == "paging" && state.action.name == "actionBegin") {
  //     // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
  //     if (this.arraycol.length != 0) {
  //       if (this.arraycol[0].Client.Pagesize != state.take) {
  //         this.arraycol[0].Client.Pagesize = state.take
  //         this.SaveColumnwidth();
  //         // }
  //       }
  //     }
  //   }
  //   this.getClientListDetails();
  // }
    //.........................................onActionClient.....................................................
    public onActionClient(cli) {
      this.getClient.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
      this.getClient.pageitem = this.grid.pagerModule.pagerObj.pageSize;
      if (cli.name == "actionBegin" && cli.requestType == "filterbeforeopen") {
        this.getClient.type = cli.columnType
      }
    }
  id: string = "00000000-0000-0000-0000-000000000000";

  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);

    this.ColumnArray = this.arraycol[0].Client.Columns;
    let showcol = this.arraycol[0].Client.ShowColumns;
    let hidecol = this.arraycol[0].Client.HideColumns
    //   this.grid.showColumns(showcol);
    this.grid.hideColumns(hidecol);

    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].Client.Pagesize;
    this.ColumnArray.forEach(element => {

      if (element.column == 'Name') {

        const column = this.grid.getColumnByField('name'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }
      if (element.column == 'Medicaid') {

        const column = this.grid.getColumnByField('medicaid'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }

      if (element.column == 'DOB') {

        const column1 = this.grid.getColumnByField('dob'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'QP Name') {

        const column1 = this.grid.getColumnByField('qPname'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Primary Physician') {

        const column1 = this.grid.getColumnByField('primaryPhysician'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Age') {

        const column1 = this.grid.getColumnByField('age'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Phone') {

        const column1 = this.grid.getColumnByField('phone1'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Location') {

        const column2 = this.grid.getColumnByField('locationName'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'Street') {

        const column1 = this.grid.getColumnByField('street'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Zip Code') {

        const column1 = this.grid.getColumnByField('zipCode'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Status') {

        const column1 = this.grid.getColumnByField('status_Name'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'lastEligibility') {

        const column1 = this.grid.getColumnByField('lastEligibility'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'checkeligibility') {

        const column2 = this.grid.getColumnByUid('checkeligibility'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'MA Eligible') {

        const column2 = this.grid.getColumnByField('isMAEligible'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'Actions') {

        const column2 = this.grid.getColumnByUid('action'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'Client Insurance ID') {

        const column = this.grid.getColumnByField('insuranceNo'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }
      if (element.column == 'Languages') {

        const column = this.grid.getColumnByField('languages'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }
    });
  }
  SaveColumnwidth() {
    this.arraycol[0].Client.Columns = this.ColumnArray;
    this.arraycol[0].Client.Pagesize = this.grid.pageSettings.pageSize;
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.http.savecolumwidth(this.columnchange).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }


  AddClient(modalType: string) {
    if (modalType == 'new') {
      this.EditOptions.clientData = new ClientBO();
      this.EditOptions.isEdit = true;
      this.EditOptions.isclientfilterEnable = true;
      this.EventToEdit.emit(this.EditOptions);
      this.EditOptions.isnewClient = true;
      this.EditOptions.newclient =true
    }
    else {
      this.EditOptions.newclient =false
     
      this.EditOptions.isnewClient = false;
      this.EditOptions.isEdit = true;
      this.EditOptions.isEditClient = true;
      this.EditOptions.isclientfilterEnable = true;
      this.EventToEdit.emit(this.EditOptions);
    }
    this.global.docbool=false;

  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50); // give X and Y axis
  }




  //=================================Clientdatatobind====================//
  Clientdatatobind(data: any) {
    this.EditOptions.clientId = data.id
    this.global.clientId=data.id;
    this.EditOptions.clientData = this.global.globalclientdata = data;
    this.EditOptions.clientData.dOB = data.dob

  }
  getClient: GetListBase = new GetListBase();
  clientFilter = new clientFilter();
  private onDestroy$: Subject<void> = new Subject<void>();

  //==============================getClientList=============================//
  getClientListerr: any = ""
  isDatashowfilter: boolean = false;
  getClientListDetails() {
    // this.getClient.statusLId = this.clientFilter.clientStatus;

   this.getClient.locationID=this.locationId;

    this.clienttserivce.execute(this.getClient);
    let val = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if ((data != null && data.result.length > 0)) {
        this.isDatashowfilter = true;
      }
      else {
        this.isDatashowfilter = false;
      }

      val++;
      if (data != null && data != undefined && val == 1) {
        // this.getColumnwidth();
        if (data.result.length > 15) {
          this.grid.height = '500';
        }
        else {

          this.grid.height = 'auto';
        }
      }
    })

  }

  getStatus() {
    let params = new URLSearchParams();

    params.append("listCode", "STATUS");

    this.http.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.statusList = data;
      
        let values =

        {

          "id": null,

          "lovName": "ALL",

          "lovCode": "ALL",

          "lovValue": "ALL"

        }
        this.statusList.push(values);

        this.getClient.statusLId = this.statusList?.filter(s => s.lovName == "Active")[0].id;
    
    
      this.getClientListDetails();
    })
  }


  Refresh(){
    this.getStatus();
  }


  exportCsv() {

    this.http.getExportCsv().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
    let contentType = 'text/csv';
    const blob = this.b64toBlob(data.fileContents,contentType);
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = "Client Export";
    
    a.click();
    // FileSaver.saveAs(data,"Client Export");
  })
 
 

 }
 b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {

  const byteCharacters = atob(b64Data);

  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {

    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {

      byteNumbers[i] = slice.charCodeAt(i);

    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);

  }

  const blob = new Blob(byteArrays, { type: contentType });

  return blob;

}


changeClientPortalPass() {
  if(this.username == null || this.username == undefined || this.username == '') {
    this.toastrService.error("This client does not have a portal credential account.", 'Error'),8000;
    return;
  }
  let params = new URLSearchParams();   
    console.log("global.agencyCode",this.global.agencyCode,this.username)
    params.append("type","client");
    params.append("Email",this.username);
    if(this.global.agencyCode == "SUPERADMIN")  {
      params.append("AgencyCode",this.global.selectAgencyCode);
    } else {
    params.append("AgencyCode",this.global.agencyCode);
    }
    this.httpService.forgotPasswordclient(params).subscribe((data: any) => {
      if (data) {
        this.toastrService.success('Temporary password has been sent to your respective mail id',
          'Temporary password sent successfully'), 8000;     
      }      
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
}
username:any;

 resetpassword(data) {
  this.username=data.userName;
}
numberOnly(event): boolean {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}
 closeEligiblity() {
    this.ISEDI271Client = false;
    document.getElementById("EligibilityOpen").click();
  }


  openEligibility() {
    // Set up getClient with required values
   // // this.getClient.locationId = this.global.globalLocationId;
    // Set other required fields if needed
    this.ISEDI271Client = true;
    console.log('Eligibility button Clicked');
  }
}



